import Box from '@mui/material/Box';
import { Outlet } from 'react-router';

import Header from './header/Header';
import Footer from './Footer';

export default function Layout() {
  return (
    <>
      <Header></Header>
      <Box
        component='main'
        sx={{
          flex: 1,
          overflow: 'auto',
          minHeight: '70vh',
        }}
      >
        <Outlet />
      </Box>
      <Footer></Footer>
    </>
  );
}
